import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Chat(props: StickerArtProps) {
  return (
    <StickerFrame background="#0f766e" {...props}>
      <path
        d="M15 17 H49 A5 5 0 0 1 54 22 V38 A5 5 0 0 1 49 43 H31 L20 51 V43 H15 A5 5 0 0 1 10 38 V22 A5 5 0 0 1 15 17 Z"
        fill="#ffffff"
      />
      <circle cx="22" cy="30" r="3.2" fill="#1f2937" />
      <circle cx="32" cy="30" r="3.2" fill="#1f2937" />
      <circle cx="42" cy="30" r="3.2" fill="#1f2937" />
    </StickerFrame>
  );
}
